import { CoreModalDialogFooter, MMButton } from '@components'
import type { SimpleCallback } from 'mmfintech-backend-api/types'
import { GlobalContext, tr } from 'mmfintech-commons'
import { useContext } from 'react'
import styles from './NoReferenceModal.module.scss'

interface NoReferenceModalProps {
  onContinue: SimpleCallback
}

const NoReferenceModal = ({ onContinue }: NoReferenceModalProps) => {
  const { modalHide } = useContext(GlobalContext)

  const handleContinue = () => {
    onContinue()
    modalHide()
  }

  return (
    <div className={styles['no-reference-modal-wrapper']}>
      <div className='content-text'>
        {tr(
          'FRONTEND.WITHDRAW.BANK_TRANSFER.NO_REFERENCE.TEXT',
          'The recipient might not know who is making the transfer. Do you want to continue anyway?'
        )}
      </div>

      <CoreModalDialogFooter>
        <div className='modal-actions'>
          <MMButton
            type='button'
            size='large'
            variant='alternative'
            caption={tr('FRONTEND.BUTTONS.CONTINUE', 'Continue')}
            onClick={handleContinue}
            data-test='continue-button'
            fullWidth
          />
          <MMButton
            type='button'
            size='large'
            variant='tertiary'
            caption={tr('FRONTEND.BUTTONS.CANCEL', 'Cancel')}
            onClick={modalHide}
            data-test='cancel-button'
          />
        </div>
      </CoreModalDialogFooter>
    </div>
  )
}

export default NoReferenceModal
